export const COMMENT_VISIBILITY_OPTIONS = [
    { value: 'internal', label: 'Team only' },
    { value: 'public', label: 'Team and clients' },
];
export function commentVisibilityLabel(visibility) {
    return visibility === 'public' ? 'Team and clients' : 'Team only';
}
export function commentVisibilityHint(visibility) {
    return visibility === 'public'
        ? 'Clients can read this when the issue appears on their review link.'
        : 'This note stays private to your team.';
}
/** Browser preference only; every request still carries its explicit audience. */
export function getLastCommentVisibility() {
    try {
        return localStorage.getItem('oq-comment-visibility') === 'public' ? 'public' : 'internal';
    }
    catch {
        return 'internal';
    }
}
export function rememberCommentVisibility(value) {
    try {
        localStorage.setItem('oq-comment-visibility', value);
    }
    catch { /* Storage can be disabled. */ }
}
//# sourceMappingURL=issue-comments.js.map